// extracted by mini-css-extract-plugin
export default {"fdoTable":"app-portainer-settings-edge-compute-SettingsFDO-SettingsFDO-module__fdo-table"};